export type Tenant = {
  realmName: string;
  displayName: string;
  note: string;
  gatewayMonitorings: Monitoring[];
  devicesMonitorings: Monitoring[];
  systemMonitorings: Monitoring[];
  connectorMonitorings: Monitoring[];
};

export type Monitoring = {
  type: TenantMonitoringType;
  count: number;
};

export enum TenantMonitoringType {
  Unknown = 'Uknown',
  Offline = 'Offline',
  BatteryCritical = 'BatteryCritical',
  BatteryLow = 'BatteryLow',
  OutDated = 'OutDated',
  Online = 'Online',
  NotMonitored = 'NotMonitored',
  PassiveGatewayOffline = 'PassiveGatewayOffline',
  Warning = 'Warning',
  DeviceMalfunction = 'DeviceMalfunction',
}
